import React, {
  createContext,
  useState,
  useCallback,
  useContext,
  useEffect,
} from "react";
import io from "socket.io-client";

const SocketContext = createContext();
export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [conversatioRooms, setConversatioRooms] = useState([]);
  const [currentConversationId, setCurrentConversationId] = useState(null);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const initialConnectSocket = useCallback(
    (jwtToken, userId) => {
      if (!userId || !jwtToken || socket?.connected) {
        return;
      }

      const newSocket = io(process.env.REACT_APP_SOCKET_SERVER_URL, {
        auth: {
          accessToken: `Bearer ${jwtToken}`,
        },
      });

      setSocket(newSocket);
      setIsConnected(true);

      newSocket.on("connect", () => {
        setIsConnected(true);
      });

      newSocket.on("conversation:joined", (data) => {
        setConversatioRooms(data);
      });

      newSocket.on("disconnect", (reason) => {
        setIsConnected(false);
      });

      newSocket.on("presence:onlineUsersList", (data) => {
        setOnlineUsers(data?.onlineUserIds);
      });

      newSocket.on("connect_error", (error) => {
        setIsConnected(false);
      });
    },
    [socket]
  );

  const disconnectSocket = useCallback(() => {
    if (socket && socket.connected) {
      socket.disconnect();
      setSocket(null);
      setIsConnected(false);
    }
  }, [socket]);

  const handleOnlineEvent = useCallback(() => {
    if (socket && socket.connected) {
      socket.emit("presence:onlineUsersList");
    }
  }, [socket]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      handleOnlineEvent();
    }, 3000);
    return () => clearInterval(intervalId);
  }, [handleOnlineEvent]);

  return (
    <SocketContext.Provider
      value={{
        socket,
        conversatioRooms,
        onlineUsers,
        setOnlineUsers,
        isConnected,
        initialConnectSocket,
        setCurrentConversationId,
        handleOnlineEvent,
        currentConversationId,
        disconnectSocket,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};

export const useSocketContext = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error("useSocketContext must be used within a SocketProvider");
  }
  return context;
};
